const crumbNames: Record<string, string> = {
	// b2c
	karriere: 'Karriere-Tipps',
	arbeitsmarkt: 'Aktuelles zum Arbeitsmarkt',
	arbeitsrecht: 'Arbeitsalltag und Arbeitsrecht',
	'ausbildung-lehre': 'Ausbildung und Lehre',
	bewerbung: 'Bewerbung und Lebenslauf',
	jobsuche: 'Alles zur Jobsuche',
	'product-updates': 'Neuigkeiten von hokify',
	// press
	press: 'Presse & Medien',
	// b2b
	recruiting: 'Recruiting',
	'case-studies': 'Case Studies',
	blog: 'Blog',
	downloads: 'Downloads',
	upcomingevents: 'Kommende Events',
	pastevents: 'Vergangene Events',
	partners: 'Partner',
	webinar: 'Webinare',
	podcasts: 'Podcasts'
};

export const crumbsMaker = (
	mode: 'business' | 'press' | 'user',
	article?: any,
	showCategoryUrl?: boolean
): { name: string; url: string }[] => {
	const crumbs: { name: string; url: string }[] = [];

	crumbs.push({ name: 'Start', url: mode === 'business' ? '/business' : '/' });

	switch (mode) {
		case 'business':
			crumbs.push({ name: 'Recruiting', url: '/business/recruiting' });
			break;
		case 'press':
			crumbs.push({ name: 'Presse', url: '/press' });
			break;
		case 'user':
		default:
			crumbs.push({ name: 'Karriere-Tipps', url: '/karriere' });
			break;
	}

	if (article) {
		// in some regions there won't be corearticles from the beginning -> we therefore hide interlinking to these subnamespaces
		if (showCategoryUrl) {
			crumbs.push({
				name: crumbNames[article.category.identifier],
				url: `${article.category.namespace}/${article.category.url}`
			});
		}
		// only push article title into crumbs if it is not a core article
		if (!article.isCoreArticle) {
			crumbs.push({
				name: article.title,
				url: article.articleUrl
			});
		}
	}

	return crumbs;
};
